import React from 'react'
import { bool } from 'prop-types'

class DisableBodyScroll extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      scrollOffset: 0
    }
    this.disableScroll = this.disableScroll.bind(this)
    this.enableScroll = this.enableScroll.bind(this)
  }

  disableScroll() {
    if (typeof window === 'undefined') return
    const scrollOffset =
      document.body.scrollTop || document.documentElement.scrollTop
    document.body.classList.add('no-scroll')
    if (scrollOffset > 0) {
      document.body.style.top = scrollOffset * -1 + 'px'
      this.setState({ scrollOffset })
    }
  }

  enableScroll() {
    if (typeof window === 'undefined') return
    document.body.classList.remove('no-scroll')
    document.body.scrollTop = this.state.scrollOffset
    document.documentElement.scrollTop = this.state.scrollOffset
    document.body.style.top = ''
  }

  componentDidMount() {
    if (this.props.disableScroll) {
      this.disableScroll()
    }
  }
  componentDidUpdate() {
    this.props.disableScroll ? this.disableScroll() : this.enableScroll()
  }
  componentWillUnmount() {
    this.enableScroll()
  }
  render() {
    return null
  }
}

DisableBodyScroll.defaultProps = {
  disableScroll: false
}
DisableBodyScroll.propTypes = {
  disableScroll: bool
}
export default DisableBodyScroll
